<div
  class="container iep-form-container"
  style="
    margin-bottom: 192px;
    margin-left: auto;
    margin-right: auto;
    width: 97%;
  "
>
  <div class="row">
    <div class="col-lg-12">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h4 id="heading" style="margin-bottom: 3px; margin-top: 5px">
            Meter Inventory
          </h4>
        </div>

        <div class="panel-body">
          <div class="row" *ngIf="displayAllSiteID">
            <div class="col-lg-12">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input" style="margin-bottom: 3px"
                  >Select Site:</mat-label
                >
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <mat-form-field>
                  <mat-select
                    name="siteID"
                    (selectionChange)="getMeterDetails()"
                    [(ngModel)]="siteId"
                    placeholder="Select SiteID"
                    required
                  >
                    <mat-option value="">-- Select SiteID --</mat-option>
                    <mat-option
                      *ngFor="let item of sites"
                      value="{{ item.siteId }}"
                      >{{ item.siteId }}</mat-option
                    >
                  </mat-select>
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div
            class="row"
            style="margin-top: 1px; margin-bottom: 5px"
            *ngIf="!displayAllSiteID"
          >
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label> Site ID : </mat-label>{{ selectedSite }}
            </div>
          </div>
          <mat-table id="table-meter" #table [dataSource]="meterSources">
            <ng-container matColumnDef="number">
              <mat-header-cell *matHeaderCellDef> S No.</mat-header-cell>

              <mat-cell *matCellDef="let meter">{{ meter.order }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="meterId">
              <mat-header-cell *matHeaderCellDef>Meter Id</mat-header-cell>
              <mat-cell *matCellDef="let meter">{{ meter.meterId }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="loadName">
              <mat-header-cell *matHeaderCellDef>Load Name</mat-header-cell>
              <mat-cell *matCellDef="let meter">{{ meter.loadName }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="make">
              <mat-header-cell *matHeaderCellDef>MeterMake</mat-header-cell>
              <mat-cell *matCellDef="let meter">{{ meter.make }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef>MeterType</mat-header-cell>
              <mat-cell *matCellDef="let meter">{{ meter.type }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="serialNumber">
              <mat-header-cell *matHeaderCellDef>Serial Number</mat-header-cell>
              <mat-cell *matCellDef="let meter">{{
                meter.serialNumber
              }}</mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let meter; columns: displayedColumns"
            ></mat-row>
          </mat-table>

          <mat-paginator
            #paginator
            [pageSize]="10"
            [pageSizeOptions]="[10, 20, 30]"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
